import { render, staticRenderFns } from "./ModalRoleAndGroup.vue?vue&type=template&id=65cdc6d8&scoped=true"
import script from "./ModalRoleAndGroup.vue?vue&type=script&lang=js"
export * from "./ModalRoleAndGroup.vue?vue&type=script&lang=js"
import style0 from "./ModalRoleAndGroup.vue?vue&type=style&index=0&id=65cdc6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdc6d8",
  null
  
)

export default component.exports